import { render, staticRenderFns } from "./SelectedApplicant.vue?vue&type=template&id=9deb1ef4&"
import script from "./SelectedApplicant.vue?vue&type=script&lang=js&"
export * from "./SelectedApplicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports